/* @flow */

import clsx from 'clsx';
import * as React from 'react';

import type { NETGEM_API_V8_FEED_ITEM } from '../../../libs/netgemLibrary/v8/types/FeedItem';
import type { NETGEM_API_V8_HUB } from '../../../libs/netgemLibrary/v8/types/Hub';
import type { ModalState } from '../../../redux/modal/reducers';

import { AvenueType } from '../../../helpers/ui/avenue/types';
import AvenueView from '../../avenue/Avenue';
import Modal from '../modal';
import './AvenueModal.css';

export type AVENUE_DATA_MODAL_TYPE = {
  hasBackButton?: boolean,
  hub: ?NETGEM_API_V8_HUB,
  hubItem: ?NETGEM_API_V8_FEED_ITEM,
  index: number,
  isInExploreModal: boolean,
  type: AvenueType,
};

const AvenueModal = (avenueModalProps: ModalState): React.Node => {
  const { ariaLabel, avenueData } = avenueModalProps;

  if (!avenueData) {
    return null;
  }

  const { hasBackButton, hub, hubItem, index, isInExploreModal, type } = avenueData;

  return (
    <Modal ariaLabel={ariaLabel} className={clsx('avenue', (type as string).toLowerCase())}>
      <AvenueView hasBackButton={hasBackButton} hub={hub} hubItem={hubItem} index={index} isInExploreModal={isInExploreModal} key='avenue' type={type} />
    </Modal>
  );
};

export default AvenueModal;
